import { Check, Laptop, Monitor } from "lucide-react";
import { DESKTOP_PLATFORMS, type DesktopPlatform } from "../desktop-release.ts";

const PLATFORM_DETAILS: Record<
  DesktopPlatform,
  { label: string; architecture: string; Icon: typeof Laptop }
> = {
  "macos-arm64": { label: "macOS", architecture: "Apple silicon", Icon: Laptop },
  "windows-x64": { label: "Windows", architecture: "x64", Icon: Monitor }
};

interface DesktopPlatformPickerProps {
  value: DesktopPlatform;
  detectedPlatform: DesktopPlatform | null;
  disabled?: boolean;
  onChange: (platform: DesktopPlatform) => void;
}

export function DesktopPlatformPicker({
  value,
  detectedPlatform,
  disabled = false,
  onChange
}: DesktopPlatformPickerProps) {
  return (
    <div className="desktop-platform-field">
      <span className="desktop-platform-label">下载版本</span>
      <div className="desktop-platform-picker" role="group" aria-label="选择桌面系统">
        {DESKTOP_PLATFORMS.map((platform) => {
          const { label, architecture, Icon } = PLATFORM_DETAILS[platform];
          const selected = value === platform;
          return (
            <button
              className="desktop-platform-option"
              type="button"
              key={platform}
              data-selected={selected}
              aria-pressed={selected}
              disabled={disabled}
              onClick={() => onChange(platform)}
            >
              <Icon aria-hidden="true" />
              <span>
                <strong>{label}</strong>
                <small>{architecture}</small>
              </span>
              {detectedPlatform === platform ? (
                <span className="desktop-platform-detected">当前设备</span>
              ) : null}
              {selected ? <Check className="desktop-platform-check" aria-hidden="true" /> : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
